import { NgIf } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApprovalUserModel } from '@app/models/system-settings';
import { NoDataAvailableComponent } from '@app/shared/components/no-data-available/no-data-available.component';
import { ReadOnly } from '@app/utils/claims';
import { ApprovalUserParams } from './approval-user-params.model';
import { ApprovalSetupService } from '../services/approval-setup-service';

@Component({
	selector: 'ss-approval-user',
	templateUrl: './approval-user.component.html',
	styleUrls: ['./approval-user.component.less'],
	standalone: true,
	imports: [FormsModule, MatTableModule, MatCheckboxModule, NgIf, NoDataAvailableComponent],
})
export class ApprovalUserComponent implements OnInit {
	@ViewChild('fUsers') formUsers: NgForm;
	@ReadOnly() isReadOnly = false;
	columnsToDisplay: string[] = ['UserName', 'FullName', 'Selected'];
	dataSource = new MatTableDataSource<any>();
	allUsersSelected = false;
	selectedDesc: string;
	isDataLoaded = false;

	constructor(
		private readonly approvalSetupService: ApprovalSetupService,
		public readonly dialogRef: MatDialogRef<ApprovalUserComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ApprovalUserParams
	) {}

	ngOnInit(): void {
		//Hack added to prevent "Expression has changed after it was checked." error with loading component.
		//Only occurs with Modals, seems like an Angular bug
		setTimeout(() => {
			this.loadUsers();
		});
	}

	checkAllUsers(): void {
		this.dataSource.data.forEach((i) => {
			i.Selected = !this.allUsersSelected;
		});
		this.formUsers.form.markAsDirty();
		this.updateSelectedDisplay();
	}

	checkIfAllUsersSelected(): void {
		this.allUsersSelected = this.dataSource.data.every((e) => e.Selected === true);
		this.updateSelectedDisplay();
	}

	updateSelectedDisplay(): void {
		const selectCount = this.dataSource.data.filter((f) => f.Selected === true).length;
		this.selectedDesc = `${selectCount} selected out of ${this.dataSource.data.length}`;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		const approvalUsers = [];

		this.dataSource.data
			.filter((f) => f.Selected === true)
			.forEach((e) => {
				const userModel = {
					Id: e.Id,
					UserId: e.UserId,
					ApprovalLevelId: this.data.Id,
					HasChanged: true,
					Selected: true,
				} as ApprovalUserModel;
				approvalUsers.push(userModel);
			});

		this.dialogRef.close(approvalUsers);
	}

	private loadUsers(): void {
		this.isDataLoaded = false;
		this.approvalSetupService.getUsers(this.data.Id, this.data.ApprovalType).subscribe((data) => {
			this.dataSource = new MatTableDataSource<ApprovalUserModel>(data);
			this.isDataLoaded = true;
			this.checkIfAllUsersSelected();
		});
	}
}
